import { render, staticRenderFns } from "./DiamondList.vue?vue&type=template&id=36651692&scoped=true&"
import script from "./DiamondList.vue?vue&type=script&lang=js&"
export * from "./DiamondList.vue?vue&type=script&lang=js&"
import style0 from "./DiamondList.vue?vue&type=style&index=0&id=36651692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36651692",
  null
  
)

export default component.exports